<template>
  <div id="dashboard" class="logout-page">
    <div id="fondo" class="logout-bg">
      <div class="container logout-container mt-5">
        <div class="row justify-content-center mt-5">
          <div class="col-12 col-md-8 col-lg-6 mt-5">
            <div class="logout-card mt-5">
              <!-- Título -->
              <div
                class="logout-title"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Has cerrado sesión
              </div>

              <!-- Imagen -->
              <div
                class="logout-image-wrap"
                data-aos="zoom-in"
                data-aos-delay="180"
              >
                <img
                  src="../assets/imgs/dominos/sesion-terminada.png"
                  alt="Sesión terminada"
                  class="logout-image"
                />
              </div>

              <!-- Mensaje principal -->
              <div
                class="logout-message"
                data-aos="fade-up"
                data-aos-delay="260"
              >
                Gracias por participar en la promoción de Domino’s.
              </div>

              <!-- Mensaje secundario -->
              <div
                class="logout-description"
                data-aos="fade-up"
                data-aos-delay="320"
              >
                Recuerda que puedes volver cuando quieras para registrar más
                tickets y seguir sumando puntos.
              </div>

              <div class="py-5">
               <router-link to="/login" class="btnaction blanco px-5 fG bold">
                IR AL INICIO
              </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AOS from "aos";
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted() {
    AOS.init({
      offset: -120,
      delay: 0,
      duration: 800,
      easing: "ease-in-out",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    });
  },
};
</script>

<style lang="scss" scoped>
.logout-page {
  min-height: 100vh;
  background: #0d95df;
}

.logout-bg {
  min-height: calc(100vh - 120px);
  background: #0d95df;
  padding: 28px 0 50px;
}

.logout-container {
  max-width: 1000px;
}

.logout-card {
  text-align: center;
  color: #fff;
  padding: 10px 12px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logout-title {
  margin-top: 10px;
  font-size: 2.1rem;
  line-height: 1.05;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 26px;
}

.logout-image-wrap {
  margin-bottom: 34px;
}

.logout-image {
  width: 150px;
  max-width: 70%;
  height: auto;
  display: inline-block;
}

.logout-message {
  font-size: 2rem;
  line-height: 1.08;
  font-weight: 800;
  color: #ffffff;
  max-width: 520px;
  margin: 0 auto 20px;
}

.logout-description {
  font-size: 1.3rem;
  line-height: 1.2;
  color: #ffffff;
  max-width: 500px;
  margin: 0 auto;
}

@media (max-width: 767px) {
  .logout-bg {
    padding: 24px 0 35px;
    min-height: calc(100vh - 90px);
  }

  .logout-card {
    padding: 6px 14px 30px;
  }

  .logout-title {
    margin-top: 0;
    font-size: 1.15rem;
    margin-bottom: 18px;
  }

  .logout-image-wrap {
    margin-bottom: 26px;
  }

  .logout-image {
    width: 86px;
    max-width: 42%;
  }

  .logout-message {
    font-size: 0.95rem;
    line-height: 1.1;
    max-width: 245px;
    margin-bottom: 14px;
  }

  .logout-description {
    font-size: 0.72rem;
    line-height: 1.25;
    max-width: 220px;
  }
}
</style>